/**
 * Created by Wojciech Szydlak on 28.02.2018.
 */

namespace Entity.Map.Marker.Decorator {
    export abstract class Decorator {

        protected _marker: Entity.Map.Marker.Marker;
        protected _latLng: google.maps.LatLng;
        protected _map: google.maps.Map;
        protected _visible: boolean;

        constructor(marker: Entity.Map.Marker.Marker, latLng: google.maps.LatLng, map: google.maps.Map) {
            this._marker = marker;
            this._latLng = latLng;
            this._map = map;
        }

        protected append() {
            if (this._marker) {
                this._marker.appendDecorator(this);
            }
        }

        public setMap(map: google.maps.Map | null) {
            this._map = map;
        }

        public setVisible(visible: boolean) {
            this._visible = visible;
        }

        public setPosition(latLng: google.maps.LatLng) {
            this._latLng = latLng;
        }

        get marker() {
            return this.marker;
        }

        get map() {
            return this.map;
        }

        get visible() {
            return this._visible;
        }

        get latLng() {
            return this._latLng;
        }
    }
}